import { GET_SITE, ADD_SITE, UPDATE_SITE, DEL_SITE, GET_DEPARTMENT, ADD_DEPARTMENT, UPDATE_DEPARTMENT, DEL_DEPARTMENT } from "@/api/dms_portal";
import querystring from "query-string";

const state = {
    list_site: [],
    list_department: [],
};

const mutations = {
    SET_LIST_SITE: (state, payload) => {
        state.list_site = payload;
    },
    SET_LIST_DEPARTMENT: (state, payload) => {
        state.list_department = payload;
    },
};

const actions = {
    getListSite: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_SITE(params);
        const data = resp.data.result;

        commit("SET_LIST_SITE", data);
    },

    createSite: async ({ }, args) => {
        return await ADD_SITE(args);
    },
    updateSite: async ({ }, args) => {
        return await UPDATE_SITE(args);
    },
    delSite: async ({ }, id) => {
        return await DEL_SITE(id);
    },
    getListDepartment: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_DEPARTMENT(params);

        const data = resp.data.result;
        commit("SET_LIST_DEPARTMENT", data);
    },

    createDepartment: async ({ }, args) => {
        return await ADD_DEPARTMENT(args);
    },
    updateDepartment: async ({ }, args) => {
        return await UPDATE_DEPARTMENT(args);
    },
    delDepartment: async ({ }, id) => {
        return await DEL_DEPARTMENT(id);
    },

};

const getters = {
    listSite: (state) => state.list_site,
    listDepartment: (state) => state.list_department,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
